import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import ProfileApi from '../api/profileApi';
import { UserResponse, UserUpdate } from '@/schema/user';

// Get the current user's profile
export const useProfile = () => {
  return useQuery<UserResponse>({
    queryKey: ['profile'],
    queryFn: () => ProfileApi.getProfile(),
  });
};

// Update the current user's profile
export const useUpdateProfile = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (data: UserUpdate) => ProfileApi.updateProfile(data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['profile'] });
    },
  });
};
